import {
  Box, Typography, styled,
} from '@material-ui/core';

export { ContentContainer, HeaderBox, Title } from './ActivationSteps.styles';

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 14,
  marginTop: 8,
}));

export const ResendButtonBox = styled(Box)({
  marginTop: 32,
});
